import React from 'react';
import { format } from 'date-fns';

import Heading from '@common/Heading';
import Row from '@common/Row';
import Link from '@common/Link';
import Img from '@common/Image';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';


const FeaturedArticle = ({ data }) => {
  const { link, featuredImage, categories, title, date, author } = data || {};
  return (
    <Row className='mb-3 position-relative overflow-hidden scale-1-img'>
      {categories &&
        <Row className='mb-1'>
          {categories.nodes.map((category, index) => (
            <Link key={index} to={`/blog${category.link}`} className='col-auto text-uppercase fs-16'>
              {category.name}
            </Link>
          ))}
        </Row>
      }
      <div className='d-flex flex-column flex-lg-row'>
        <div className='d-flex flex-column justify-content-between col pe-2'>
          {title &&
            <Link to={`/blog${link}`}>
              <Heading type='h2' className='mt-1 mt-xl-2 text-black'>{title}</Heading>
            </Link>
          }
          {author &&
            <div className='d-flex pt-2 text-black'>
              <FontAwesomeIcon icon={faCalendar} size={'sm'} style={{maxWidth:'14px'}}/>
              {/* <p className='fs-14 ms-1'>{format(new Date(date), 'PPP') + ` | ${author.node?.name}`}</p> */}
              <p className='fs-14 fw-medium ms-1'>
                {format(new Date(date), 'PPP') + ` | `}<Link to={`/blog/author/${author?.node.slug}`} className='text-black'>{author?.node.name}</Link>
              </p>
            </div>
          }
        </div>
        {featuredImage &&
          <Link to={`/blog${link}`} className='col mb-1'>
            <div className='overflow-hidden rounded'>
              <img src={featuredImage?.node.sourceUrl} alt='' className='img-scale w-100'/>
            </div>
          </Link>  
        }
      </div>
    </Row>
  )
}

export default FeaturedArticle
